import axios from 'axios';
// import { useRef } from 'react';
import { environment } from '../../environment';

export async function ageingPeriodAPI() {
  // const source = useRef(axios.CancelToken.source());
  try {
    let response = await axios.get(
      `${environment.reportingEndpoint}/api/v1/internal/ageingperiods`,

      // { cancelToken: source.current.token }
    );

    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      throw e;
    }
  }
}
